import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'
import config from '@/config'

Vue.use(AclInstaller)

let initialRole = 'public'

const userInfo = JSON.parse(localStorage.getItem('auth-values'))
if(userInfo){
  if(config.USER_ROLE_ALL_ADMIN.includes(userInfo.user_default_role_id)){
    initialRole = "admin"
  }else{
    initialRole = "user"
  }
}
// alert(initialRole);

// export default new AclCreate({
//   initial  : initialRole,
//   notfound : '/pages/not-authorized',
//   router,
//   acceptLocalRules : true,
//   globalRules: {
//     isAdmin  : new AclRule('admin').generate(),
//     isUser  : new AclRule('user').generate(),
//     isPublic : new AclRule('user').or('admin').or('public').generate(),
//   },
//   middleware: async acl => {
//     await timeout(2000) // call your api
//   }
// })
